import { render, staticRenderFns } from "./PwaButton.vue?vue&type=template&id=328d988c&"
import script from "./PwaButton.ts?vue&type=script&lang=js&"
export * from "./PwaButton.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports